import { Injectable } from '@angular/core';
import { Subject, filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private eventSubject = new Subject<any>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  publish(eventName: string, data: any) {
    this.eventSubject.next({ eventName, data });
  }

  getEvent(eventName: string) {
    return this.eventSubject.asObservable().pipe(
      filter(event => event.eventName === eventName),
      map(event => event.data)
    );
  }
}